import {Form, Input} from 'antd';

import {AdditionalInfo} from '../../../../../../layout/additional-info/additional-info';
import {Locale} from '../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {BulkEditFieldNameEnum} from '../../../../../../service/company/company-type';
import {BaseCompanyFormItemPropsType} from '../company-form-items-type';

type PropsType = BaseCompanyFormItemPropsType<BulkEditFieldNameEnum.alternativeNames, string> & {
    className?: string;
};

export function AlternativeNamesFormItem(props: PropsType): JSX.Element {
    const {value, onChange, className, errorMessage} = props;

    const {getLocalizedString} = useLocale();

    return (
        <Form.Item
            className={className}
            help={errorMessage}
            label={
                <AdditionalInfo
                    leftNode={<Locale stringKey="GENERAL_INFO__LABEL__ALTERNATIVE_NAMES" />}
                    title={<Locale stringKey="GENERAL_INFO__LABEL__ALTERNATIVE_NAMES_INFO" />}
                >
                    <Locale stringKey="GENERAL_INFO__HINT__ALTERNATIVE_NAMES" />
                </AdditionalInfo>
            }
            validateStatus={errorMessage ? 'error' : ''}
        >
            <Input
                onChange={(event) => onChange(event.target.value)}
                placeholder={getLocalizedString('GENERAL_INFO__PLACEHOLDER__ALTERNATIVE_NAMES')}
                size="large"
                value={value}
            />
        </Form.Item>
    );
}
